import React from "react";
import { connect } from "react-redux";
import ClientSideTable from "components/data-display/client-side-table/ClientSideTable";

const Downloads = props => {
  return (
    <div>
      <div className="plr-15">
        <ClientSideTable />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(Downloads);
